import type { ComponentType } from 'react';

import { GENERATION_TOOL, type GenerationTool } from 'src/data/generationTool';
import { isDocumentProjectType, isLongFormProjectType, type ProjectType } from 'src/data/project';

import { AIDA } from './assets/AIDA';
import { AmazonProductListing } from './assets/AmazonProductListing';
import { Article } from './assets/Article';
import { BlogPostTopicIdes } from './assets/BlogPostTopicIdes';
import { BlogWizard } from './assets/BlogWizard';
import { ContentImprover } from './assets/ContentImprover';
import { Email } from './assets/Email';
import { EmailSubjectLine } from './assets/EmailSubjectLine';
import { FacebookAd } from './assets/FacebookAd';
import { FacebookPost } from './assets/FacebookPost';
import { FifthGrader } from './assets/FifthGrader';
import { GeneralProductListing } from './assets/GeneralProductListing';
import { GoogleRSA } from './assets/GoogleRSA';
import { GoogleSearchAdDescription } from './assets/GoogleSearchAdDescription';
import { GoogleSearchHeadline } from './assets/GoogleSearchHeadline';
import { ImageWithDescription } from './assets/ImageWithDescription';
import { InstagramCaption } from './assets/InstagramCaption';
import { LandingPageBenefits } from './assets/LandingPageBenefits';
import { LandingPageCTA } from './assets/LandingPageCTA';
import { LandingPageFeatures } from './assets/LandingPageFeatures';
import { LandingPageHeadline } from './assets/LandingPageHeadline';
import { LandingPageSubheader } from './assets/LandingPageSubheader';
import { LinkedinAd } from './assets/LinkedinAd';
import { LinkedinPost } from './assets/LinkedinPost';
import { LongFormSavedTemplate } from './assets/LongFormSavedTemplate';
import { NewDocument } from './assets/NewDocument';
import { OutbarainAdHeadline } from './assets/OutbarainAdHeadline';
import { PAS } from './assets/PAS';
import { PerfectProductHeadline } from './assets/PerfectProductHeadline';
import { PinterestAd } from './assets/PinterestAd';
import { PinterestPinDescription } from './assets/PinterestPinDescription';
import { PinterestPinTitle } from './assets/PinterestPinTitle';
import { ProductLandingPage } from './assets/ProductLandingPage';
import { ProductLaunchCampaign } from './assets/ProductLaunchCampaign';
import { ProductReview } from './assets/ProductReview';
import { PromotionalSMS } from './assets/PromotionalSMS';
import { Prompt } from './assets/Prompt';
import { SentenceExpander } from './assets/SentenceExpander';
import { SEOMetaDescription } from './assets/SEOMetaDescription';
import { ShortFormSavedTemplate } from './assets/ShortFormSavedTemplate';
import { AIDA as SmallAIDA } from './assets/small/AIDA';
import { AmazonProductListing as SmallAmazonProductListing } from './assets/small/AmazonProductListing';
import { Article as SmallArticle } from './assets/small/Article';
import { BlogPostTopicIdes as SmallBlogPostTopicIdes } from './assets/small/BlogPostTopicIdes';
import { BlogWizard as SmallBlogWizard } from './assets/small/BlogWizard';
import { ContentImprover as SmallContentImprover } from './assets/small/ContentImprover';
import { Email as SmallEmail } from './assets/small/Email';
import { EmailSubjectLine as SmallEmailSubjectLine } from './assets/small/EmailSubjectLine';
import { FacebookAd as SmallFacebookAd } from './assets/small/FacebookAd';
import { FacebookPost as SmallFacebookPost } from './assets/small/FacebookPost';
import { FifthGrader as SmallFifthGrader } from './assets/small/FifthGrader';
import { GeneralProductListing as SmallGeneralProductListing } from './assets/small/GeneralProductListing';
import { GoogleRSA as SmallGoogleRSA } from './assets/small/GoogleRSA';
import { GoogleSearchAdDescription as SmallGoogleSearchAdDescription } from './assets/small/GoogleSearchAdDescription';
import { GoogleSearchHeadline as SmallGoogleSearchHeadline } from './assets/small/GoogleSearchHeadline';
import { InstagramCaption as SmallInstagramCaption } from './assets/small/InstagramCaption';
import { LandingPageBenefits as SmallLandingPageBenefits } from './assets/small/LandingPageBenefits';
import { LandingPageCTA as SmallLandingPageCTA } from './assets/small/LandingPageCTA';
import { LandingPageFeatures as SmallLandingPageFeatures } from './assets/small/LandingPageFeatures';
import { LandingPageHeadline as SmallLandingPageHeadline } from './assets/small/LandingPageHeadline';
import { LandingPageSubheader as SmallLandingPageSubheader } from './assets/small/LandingPageSubheader';
import { LinkedinAd as SmallLinkedinAd } from './assets/small/LinkedinAd';
import { LinkedinPost as SmallLinkedinPost } from './assets/small/LinkedinPost';
import { NewDocument as SmallNewDocument } from './assets/small/NewDocument';
import { OutbarainAdHeadline as SmallOutbarainAdHeadline } from './assets/small/OutbarainAdHeadline';
import { PAS as SmallPAS } from './assets/small/PAS';
import { PerfectProductHeadline as SmallPerfectProductHeadline } from './assets/small/PerfectProductHeadline';
import { PinterestAd as SmallPinterestAd } from './assets/small/PinterestAd';
import { PinterestPinDescription as SmallPinterestPinDescription } from './assets/small/PinterestPinDescription';
import { PinterestPinTitle as SmallPinterestPinTitle } from './assets/small/PinterestPinTitle';
import { ProductLandingPage as SmallProductLandingPage } from './assets/small/ProductLandingPage';
import { ProductLaunchCampaign as SmallProductLaunchCampaign } from './assets/small/ProductLaunchCampaign';
import { ProductReview as SmallProductReview } from './assets/small/ProductReview';
import { PromotionalSMS as SmallPromotionalSMS } from './assets/small/PromotionalSMS';
import { Prompt as SmallPrompt } from './assets/small/Prompt';
import { SentenceExpander as SmallSentenceExpander } from './assets/small/SentenceExpander';
import { SEOMetaDescription as SmallSEOMetaDescription } from './assets/small/SEOMetaDescription';
import { Summarizer as SmallSummarizer } from './assets/small/Summarizer';
import { TaboolaAdHeadline as SmallTaboolaAdHeadline } from './assets/small/TaboolaAdHeadline';
import { TalkingPointsToParagraph as SmallTalkingPointsToParagraph } from './assets/small/TalkingPointsToParagraph';
import { WalmartProductListings as SmallWalmartProductListings } from './assets/small/WalmartProductListings';
import { WelcomeEmailDrip as SmallWelcomeEmailDrip } from './assets/small/WelcomeEmailDrip';
import { XAd as SmallXAd } from './assets/small/XAd';
import { XPost as SmallXPost } from './assets/small/XPost';
import { YoutubeVideoDescription as SmallYoutubeVideoDescription } from './assets/small/YoutubeVideoDescription';
import { Summarizer } from './assets/Summarizer';
import { TaboolaAdHeadline } from './assets/TaboolaAdHeadline';
import { TalkingPointsToParagraph } from './assets/TalkingPointsToParagraph';
import { WalmartProductListings } from './assets/WalmartProductListings';
import { WelcomeEmailDrip } from './assets/WelcomeEmailDrip';
import { XAd } from './assets/XAd';
import { XPost } from './assets/XPost';
import { YoutubeVideoDescription } from './assets/YoutubeVideoDescription';
import { YoutubeVideoTitle } from './assets/YoutubeVideoTitle';
import { GENERATION_TOOL_CARD_IMAGE_SIZE, type GenerationToolCardImageSize } from './const';

const LARGE_IMAGES: Partial<Record<GenerationTool, ComponentType>> = {
  // "basic" and "basic DD"
  [GENERATION_TOOL.basicContentImprover]: ContentImprover,
  [GENERATION_TOOL.basicEli5]: FifthGrader,
  [GENERATION_TOOL.basicSentenceExpander]: SentenceExpander,
  [GENERATION_TOOL.basicAida]: AIDA,
  [GENERATION_TOOL.basicPas]: PAS,
  [GENERATION_TOOL.basicPerfectHeadline]: PerfectProductHeadline,
  [GENERATION_TOOL.basicProductDescriptionList]: GeneralProductListing,
  [GENERATION_TOOL.basicProductDescriptionRelaxed]: GeneralProductListing,
  [GENERATION_TOOL.basicBlogIdeas]: BlogPostTopicIdes,
  [GENERATION_TOOL.basicTalkingPointsToParagraph]: TalkingPointsToParagraph,
  [GENERATION_TOOL.basicProductReview]: ProductReview,
  [GENERATION_TOOL.summarizer]: Summarizer,
  [GENERATION_TOOL.generalPrompt]: Prompt,

  // "data driven"
  [GENERATION_TOOL.facebookMixtureAd]: FacebookAd,
  [GENERATION_TOOL.facebookPrimaryTextProduct]: FacebookAd,
  [GENERATION_TOOL.facebookPrimaryTextProductRewrite]: FacebookAd,
  [GENERATION_TOOL.facebookHeadlineProduct]: FacebookAd,
  [GENERATION_TOOL.googleAppAd]: GoogleRSA,
  [GENERATION_TOOL.googleDemandGenAd]: GoogleRSA,
  [GENERATION_TOOL.googleDisplayAd]: GoogleRSA,
  [GENERATION_TOOL.googleShoppingAd]: GoogleRSA,
  [GENERATION_TOOL.googleVideoAd]: GoogleRSA,
  [GENERATION_TOOL.googleRSA]: GoogleRSA,
  [GENERATION_TOOL.googleDescriptionProduct]: GoogleSearchAdDescription,
  [GENERATION_TOOL.googleHeadlineProductRewrite]: GoogleSearchHeadline,
  [GENERATION_TOOL.googleDescriptionProductRewrite]: GoogleSearchAdDescription,
  [GENERATION_TOOL.googleHeadlineProduct]: GoogleSearchHeadline,
  [GENERATION_TOOL.googlePerformanceMaxAd]: GoogleSearchHeadline,
  [GENERATION_TOOL.outbrainAd]: OutbarainAdHeadline,
  [GENERATION_TOOL.outbrainHeadlineProduct]: OutbarainAdHeadline,
  [GENERATION_TOOL.outbrainHeadlineProductRewrite]: OutbarainAdHeadline,
  [GENERATION_TOOL.taboolaAd]: TaboolaAdHeadline,
  [GENERATION_TOOL.taboolaHeadlineProduct]: TaboolaAdHeadline,
  [GENERATION_TOOL.taboolaHeadlineProductRewrite]: TaboolaAdHeadline,
  [GENERATION_TOOL.twitterMixtureAd]: XAd,
  [GENERATION_TOOL.twitterCopyProduct]: XAd,
  [GENERATION_TOOL.twitterCopyProductRewrite]: XAd,
  [GENERATION_TOOL.twitterTitleProduct]: XAd,
  [GENERATION_TOOL.pinterestMixtureAd]: PinterestAd,
  [GENERATION_TOOL.pinterestDescriptionProduct]: PinterestPinDescription,
  [GENERATION_TOOL.pinterestDescriptionProductRewrite]: PinterestPinDescription,
  [GENERATION_TOOL.pinterestTitleProduct]: PinterestPinTitle,
  [GENERATION_TOOL.landingHeadline]: LandingPageHeadline,
  [GENERATION_TOOL.landingHeadlineRewrite]: LandingPageHeadline,
  [GENERATION_TOOL.landingSubheader]: LandingPageSubheader,
  [GENERATION_TOOL.landingSubheaderRewrite]: LandingPageSubheader,
  [GENERATION_TOOL.landingCTA]: LandingPageCTA,
  [GENERATION_TOOL.landingBenefits]: LandingPageBenefits,
  [GENERATION_TOOL.landingFeatures]: LandingPageFeatures,
  [GENERATION_TOOL.landingSEOMetadata]: SEOMetaDescription,
  [GENERATION_TOOL.landingSEOMetadataRewrite]: SEOMetaDescription,
  [GENERATION_TOOL.amazonProductListing]: AmazonProductListing,
  [GENERATION_TOOL.walmartProductListing]: WalmartProductListings,
  [GENERATION_TOOL.instagramCaption]: InstagramCaption,
  [GENERATION_TOOL.facebookPost]: FacebookPost,
  [GENERATION_TOOL.tweet]: XPost,
  [GENERATION_TOOL.linkedinPost]: LinkedinPost,
  [GENERATION_TOOL.linkedinPostRewrite]: LinkedinPost,
  [GENERATION_TOOL.pinterestMixturePost]: PinterestPinDescription,
  [GENERATION_TOOL.youtubeMixturePost]: YoutubeVideoDescription,
  [GENERATION_TOOL.pinterestPostDescription]: PinterestPinDescription,
  [GENERATION_TOOL.pinterestPostTitle]: PinterestPinTitle,
  [GENERATION_TOOL.youtubeTitle]: YoutubeVideoTitle,
  [GENERATION_TOOL.youtubeDescription]: YoutubeVideoDescription,
  [GENERATION_TOOL.emailSubjectLine]: EmailSubjectLine,
  [GENERATION_TOOL.emailPromotionalSubjectLine]: EmailSubjectLine,
  [GENERATION_TOOL.emailPromotionalBody]: Email,
  [GENERATION_TOOL.emailColdOutreachSubjectLine]: EmailSubjectLine,
  [GENERATION_TOOL.emailColdOutreachBody]: Email,
  [GENERATION_TOOL.emailColdOutreachBodyRewrite]: Email,
  [GENERATION_TOOL.emailPromotionalBodyRewrite]: Email,
  [GENERATION_TOOL.emailBodyRewrite]: Email,
  [GENERATION_TOOL.emailSubject]: EmailSubjectLine,
  [GENERATION_TOOL.emailBody]: Email,
  [GENERATION_TOOL.emailMixture]: Email,
  [GENERATION_TOOL.emailSubjectRewrite]: EmailSubjectLine,
  [GENERATION_TOOL.smsPromotional]: PromotionalSMS,
  [GENERATION_TOOL.smsPromotionalRewrite]: PromotionalSMS,
  [GENERATION_TOOL.facebookPrimaryTextContent]: FacebookAd,
  [GENERATION_TOOL.facebookHeadlineContent]: FacebookAd,
  [GENERATION_TOOL.outbrainHeadlineContent]: OutbarainAdHeadline,
  [GENERATION_TOOL.taboolaHeadlineContent]: TaboolaAdHeadline,
  [GENERATION_TOOL.twitterCopyContent]: XAd,
  [GENERATION_TOOL.pinterestDescriptionContent]: PinterestAd,
  [GENERATION_TOOL.pinterestTitleContent]: PinterestAd,
  [GENERATION_TOOL.generalProductListing]: GeneralProductListing,
  [GENERATION_TOOL.linkedinHeadlineSingleImageRewrite]: LinkedinAd,
  [GENERATION_TOOL.linkedinIntroSingleImageRewrite]: LinkedinAd,
  [GENERATION_TOOL.instagramCaptionRewrite]: InstagramCaption,
  [GENERATION_TOOL.facebookPostRewrite]: FacebookPost,
  [GENERATION_TOOL.pinterestPinTitleRewrite]: PinterestPinTitle,
  [GENERATION_TOOL.pinterestPinDescriptionRewrite]: PinterestPinDescription,
  [GENERATION_TOOL.tweetRewrite]: XPost,
  [GENERATION_TOOL.linkedinMixtureAd]: LinkedinAd,
  [GENERATION_TOOL.linkedinHeadlineSingleImage]: LinkedinAd,
  [GENERATION_TOOL.linkedinIntroSingleImage]: LinkedinAd,
  [GENERATION_TOOL.linkedinDocumentAd]: LinkedinAd,
  [GENERATION_TOOL.linkedinVideoAd]: LinkedinAd,
  [GENERATION_TOOL.linkedinTextAd]: LinkedinAd,
  [GENERATION_TOOL.linkedinMessageAd]: LinkedinAd,
  [GENERATION_TOOL.linkedinConversationAd]: LinkedinAd,
  [GENERATION_TOOL.linkedinLeadGenFormAd]: LinkedinAd,
  [GENERATION_TOOL.articleBlogHeadline]: Article,
  [GENERATION_TOOL.imageWithDescription]: ImageWithDescription,
  [GENERATION_TOOL.imageByStyle]: ImageWithDescription,

  // "Multi-prompt" tools
  [GENERATION_TOOL.productLaunchMultiPrompt]: ProductLaunchCampaign,
  [GENERATION_TOOL.landingPageProductAnnouncementMultiPrompt]: ProductLandingPage,
  [GENERATION_TOOL.emailDripMultiPrompt]: WelcomeEmailDrip,

  // Freestyle
  [GENERATION_TOOL.freestyle]: Prompt,
  [GENERATION_TOOL.createYourOwn]: Prompt,

  // "Blog" project type
  [GENERATION_TOOL.blogDescription]: BlogWizard,

  // "WTM" project type
  [GENERATION_TOOL.lpcoLandingHeadline]: LandingPageHeadline,
  [GENERATION_TOOL.lpcoLandingCTA]: LandingPageCTA,

  // "New" cards
  [GENERATION_TOOL.longFormBlank]: NewDocument,
};

// The medium size draws the artwork kept in `assets/small`, which is named for the folder it has
// always been in rather than for the size that reaches for it.
const MEDIUM_IMAGES: Partial<Record<GenerationTool, ComponentType>> = {
  // "basic" and "basic DD"
  [GENERATION_TOOL.basicContentImprover]: SmallContentImprover,
  [GENERATION_TOOL.basicEli5]: SmallFifthGrader,
  [GENERATION_TOOL.basicSentenceExpander]: SmallSentenceExpander,
  [GENERATION_TOOL.basicAida]: SmallAIDA,
  [GENERATION_TOOL.basicPas]: SmallPAS,
  [GENERATION_TOOL.basicPerfectHeadline]: SmallPerfectProductHeadline,
  [GENERATION_TOOL.basicProductDescriptionList]: SmallGeneralProductListing,
  [GENERATION_TOOL.basicProductDescriptionRelaxed]: SmallGeneralProductListing,
  [GENERATION_TOOL.basicBlogIdeas]: SmallBlogPostTopicIdes,
  [GENERATION_TOOL.basicTalkingPointsToParagraph]: SmallTalkingPointsToParagraph,
  [GENERATION_TOOL.basicProductReview]: SmallProductReview,
  [GENERATION_TOOL.summarizer]: SmallSummarizer,
  [GENERATION_TOOL.generalPrompt]: SmallPrompt,

  // "data driven"
  [GENERATION_TOOL.facebookMixtureAd]: SmallFacebookAd,
  [GENERATION_TOOL.facebookPrimaryTextProduct]: SmallFacebookAd,
  [GENERATION_TOOL.facebookPrimaryTextProductRewrite]: SmallFacebookAd,
  [GENERATION_TOOL.facebookHeadlineProduct]: SmallFacebookAd,
  [GENERATION_TOOL.googleAppAd]: SmallGoogleRSA,
  [GENERATION_TOOL.googleDemandGenAd]: SmallGoogleRSA,
  [GENERATION_TOOL.googleDisplayAd]: SmallGoogleRSA,
  [GENERATION_TOOL.googleShoppingAd]: SmallGoogleRSA,
  [GENERATION_TOOL.googleVideoAd]: SmallGoogleRSA,
  [GENERATION_TOOL.googleRSA]: SmallGoogleRSA,
  [GENERATION_TOOL.googleDescriptionProduct]: SmallGoogleSearchAdDescription,
  [GENERATION_TOOL.googleHeadlineProductRewrite]: SmallGoogleSearchHeadline,
  [GENERATION_TOOL.googleDescriptionProductRewrite]: SmallGoogleSearchAdDescription,
  [GENERATION_TOOL.googleHeadlineProduct]: SmallGoogleSearchHeadline,
  [GENERATION_TOOL.googlePerformanceMaxAd]: SmallGoogleSearchHeadline,
  [GENERATION_TOOL.outbrainHeadlineProduct]: SmallOutbarainAdHeadline,
  [GENERATION_TOOL.outbrainHeadlineProductRewrite]: SmallOutbarainAdHeadline,
  [GENERATION_TOOL.outbrainAd]: SmallOutbarainAdHeadline,
  [GENERATION_TOOL.taboolaAd]: SmallTaboolaAdHeadline,
  [GENERATION_TOOL.taboolaHeadlineProduct]: SmallTaboolaAdHeadline,
  [GENERATION_TOOL.taboolaHeadlineProductRewrite]: SmallTaboolaAdHeadline,
  [GENERATION_TOOL.twitterMixtureAd]: SmallXAd,
  [GENERATION_TOOL.twitterCopyProduct]: SmallXAd,
  [GENERATION_TOOL.twitterCopyProductRewrite]: SmallXAd,
  [GENERATION_TOOL.twitterTitleProduct]: SmallXAd,
  [GENERATION_TOOL.imageWithDescription]: SmallPrompt,
  [GENERATION_TOOL.imageByStyle]: SmallPrompt,
  [GENERATION_TOOL.pinterestMixtureAd]: SmallPinterestAd,
  [GENERATION_TOOL.pinterestDescriptionProduct]: SmallPinterestPinDescription,
  [GENERATION_TOOL.pinterestDescriptionProductRewrite]: SmallPinterestPinDescription,
  [GENERATION_TOOL.pinterestTitleProduct]: SmallPinterestPinTitle,
  [GENERATION_TOOL.landingHeadline]: SmallLandingPageHeadline,
  [GENERATION_TOOL.landingHeadlineRewrite]: SmallLandingPageHeadline,
  [GENERATION_TOOL.landingSubheader]: SmallLandingPageSubheader,
  [GENERATION_TOOL.landingSubheaderRewrite]: SmallLandingPageSubheader,
  [GENERATION_TOOL.landingCTA]: SmallLandingPageCTA,
  [GENERATION_TOOL.landingBenefits]: SmallLandingPageBenefits,
  [GENERATION_TOOL.landingFeatures]: SmallLandingPageFeatures,
  [GENERATION_TOOL.landingSEOMetadata]: SmallSEOMetaDescription,
  [GENERATION_TOOL.landingSEOMetadataRewrite]: SmallSEOMetaDescription,
  [GENERATION_TOOL.amazonProductListing]: SmallAmazonProductListing,
  [GENERATION_TOOL.walmartProductListing]: SmallWalmartProductListings,
  [GENERATION_TOOL.instagramCaption]: SmallInstagramCaption,
  [GENERATION_TOOL.facebookPost]: SmallFacebookPost,
  [GENERATION_TOOL.tweet]: SmallXPost,
  [GENERATION_TOOL.linkedinPost]: SmallLinkedinPost,
  [GENERATION_TOOL.linkedinPostRewrite]: SmallLinkedinPost,
  [GENERATION_TOOL.pinterestMixturePost]: SmallPinterestPinDescription,
  [GENERATION_TOOL.youtubeMixturePost]: SmallYoutubeVideoDescription,
  [GENERATION_TOOL.emailSubjectLine]: SmallEmailSubjectLine,
  [GENERATION_TOOL.emailPromotionalSubjectLine]: SmallEmailSubjectLine,
  [GENERATION_TOOL.emailPromotionalBody]: SmallEmail,
  [GENERATION_TOOL.emailColdOutreachSubjectLine]: SmallEmailSubjectLine,
  [GENERATION_TOOL.emailColdOutreachBody]: SmallEmail,
  [GENERATION_TOOL.emailColdOutreachBodyRewrite]: SmallEmail,
  [GENERATION_TOOL.emailPromotionalBodyRewrite]: SmallEmail,
  [GENERATION_TOOL.emailBodyRewrite]: SmallEmail,
  [GENERATION_TOOL.emailSubject]: SmallEmailSubjectLine,
  [GENERATION_TOOL.emailBody]: SmallEmail,
  [GENERATION_TOOL.emailMixture]: SmallEmail,
  [GENERATION_TOOL.emailSubjectRewrite]: SmallEmailSubjectLine,
  [GENERATION_TOOL.smsPromotional]: SmallPromotionalSMS,
  [GENERATION_TOOL.smsPromotionalRewrite]: SmallPromotionalSMS,
  [GENERATION_TOOL.facebookPrimaryTextContent]: SmallFacebookAd,
  [GENERATION_TOOL.facebookHeadlineContent]: SmallFacebookAd,
  [GENERATION_TOOL.outbrainHeadlineContent]: SmallOutbarainAdHeadline,
  [GENERATION_TOOL.taboolaHeadlineContent]: SmallTaboolaAdHeadline,
  [GENERATION_TOOL.twitterCopyContent]: SmallXAd,
  [GENERATION_TOOL.pinterestDescriptionContent]: SmallPinterestAd,
  [GENERATION_TOOL.pinterestTitleContent]: SmallPinterestAd,
  [GENERATION_TOOL.generalProductListing]: SmallGeneralProductListing,
  [GENERATION_TOOL.linkedinHeadlineSingleImageRewrite]: SmallLinkedinAd,
  [GENERATION_TOOL.linkedinIntroSingleImageRewrite]: SmallLinkedinAd,
  [GENERATION_TOOL.instagramCaptionRewrite]: SmallInstagramCaption,
  [GENERATION_TOOL.facebookPostRewrite]: SmallFacebookPost,
  [GENERATION_TOOL.pinterestPinTitleRewrite]: SmallPinterestPinTitle,
  [GENERATION_TOOL.pinterestPinDescriptionRewrite]: SmallPinterestPinDescription,
  [GENERATION_TOOL.tweetRewrite]: SmallXPost,
  [GENERATION_TOOL.linkedinMixtureAd]: SmallLinkedinAd,
  [GENERATION_TOOL.linkedinDocumentAd]: SmallLinkedinAd,
  [GENERATION_TOOL.linkedinVideoAd]: SmallLinkedinAd,
  [GENERATION_TOOL.linkedinTextAd]: SmallLinkedinAd,
  [GENERATION_TOOL.linkedinMessageAd]: SmallLinkedinAd,
  [GENERATION_TOOL.linkedinConversationAd]: SmallLinkedinAd,
  [GENERATION_TOOL.linkedinLeadGenFormAd]: SmallLinkedinAd,
  [GENERATION_TOOL.linkedinHeadlineSingleImage]: SmallLinkedinAd,
  [GENERATION_TOOL.linkedinIntroSingleImage]: SmallLinkedinAd,
  [GENERATION_TOOL.articleBlogHeadline]: SmallArticle,

  // "Multi-prompt" tools
  [GENERATION_TOOL.productLaunchMultiPrompt]: SmallProductLaunchCampaign,
  [GENERATION_TOOL.landingPageProductAnnouncementMultiPrompt]: SmallProductLandingPage,
  [GENERATION_TOOL.emailDripMultiPrompt]: SmallWelcomeEmailDrip,

  // Freestyle
  [GENERATION_TOOL.freestyle]: SmallPrompt,
  [GENERATION_TOOL.createYourOwn]: SmallPrompt,

  // "Blog" project type
  [GENERATION_TOOL.blogDescription]: SmallBlogWizard,

  // "WTM" project type
  [GENERATION_TOOL.lpcoLandingHeadline]: SmallLandingPageHeadline,
  [GENERATION_TOOL.lpcoLandingCTA]: SmallLandingPageCTA,

  // "New" cards
  [GENERATION_TOOL.longFormBlank]: SmallNewDocument,
};

const LONG_FORM_IMAGES: Partial<Record<GenerationTool, ComponentType>> = {
  [GENERATION_TOOL.customMultiPrompt]: LongFormSavedTemplate,
};

const SHORT_FORM_IMAGES: Partial<Record<GenerationTool, ComponentType>> = {
  [GENERATION_TOOL.customMultiPrompt]: ShortFormSavedTemplate,
};

/** The card artwork for a tool. The smallest size draws no artwork, so it never asks for one. */
export const getGenerationToolCardImage = (
  projectType: ProjectType,
  tool: GenerationTool,
  { size }: { size: GenerationToolCardImageSize }
) => {
  const medium = size === GENERATION_TOOL_CARD_IMAGE_SIZE.medium;
  const defaultIcon = medium ? SmallPrompt : Prompt;
  const icons = medium ? MEDIUM_IMAGES : LARGE_IMAGES;

  const longFormIcon = isLongFormProjectType(projectType) && LONG_FORM_IMAGES[tool];
  const shortFormIcon = isDocumentProjectType(projectType) && SHORT_FORM_IMAGES[tool];

  if (longFormIcon) {
    return longFormIcon;
  }

  if (shortFormIcon) {
    return shortFormIcon;
  }

  return icons[tool] || defaultIcon;
};
